import { render, staticRenderFns } from "./phone1.vue?vue&type=template&id=328b6fdc&scoped=true&"
var script = {}
import style0 from "./phone1.vue?vue&type=style&index=0&id=328b6fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b6fdc",
  null
  
)

export default component.exports